import { arrayToObjectCovert } from '../../../../services/commonService';

const handleFetchLeavePoliciesFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.leavePolicy = action.payload.data;
    state.leavePolicyOrder = action.payload.data.map(policy => policy.id);
    state.currentPage = action.payload.current_page;
    state.totalPages = action.payload.total_pages;
    state.totalLeavePolicy = action.payload.total_count;
    state.lastUpdated = action.payload.last_updated;
    state.message = action.payload.message;
};

const handleFetchLeavePolicyMasterFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.leavePolicyMaster = arrayToObjectCovert(action.payload.data);
    state.leavePolicyMasterOrder = action.payload.data.map(policy => policy.id);
    state.currentPage = action.payload.current_page;
    state.totalPages = action.payload.total_pages;
    state.totalLeavePolicy = action.payload.total_count;
    state.lastUpdated = action.payload.last_updated;
    state.message = action.payload.message;
};

const handleAddLeavePolicyFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.message = action.payload.message;
};

const handleMasterLeavePolicyFulfilled = (state) => {
    state.status = 'succeeded';
}

const handleFetchLeavePolicyByIdFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.currentLeavePolicy = action.payload.data;
};

const handleFetchLeaveMasterIdFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.currentLeavePolicyMaster = action.payload.data;
}

const handleUpdateLeavePolicyFulfilled = (state, action) => {
    state.status = 'succeeded';
    // state.leavePolicy[action.payload.data.id] = action.payload.data;
    // state.currentLeavePolicy = action.payload.data;
    state.message = action.payload.message;
};

const handleUpdateMasterLeavePolicyFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.message = action.payload.message;
}

export {
    handleFetchLeavePoliciesFulfilled,
    handleFetchLeavePolicyMasterFulfilled,
    handleAddLeavePolicyFulfilled,
    handleMasterLeavePolicyFulfilled,
    handleFetchLeavePolicyByIdFulfilled,
    handleUpdateLeavePolicyFulfilled,
    handleFetchLeaveMasterIdFulfilled,
    handleUpdateMasterLeavePolicyFulfilled
};
